import { AdminUserList } from '@app/user/components/AdminUserList';

export const AdminUsersPage = () => {
  return <AdminUserList />;
};
